<template>
  <div>
    <div id="captcha"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nc_token: [
        "FFFF0N000000000093FF",
        new Date().getTime(),
        Math.random(),
      ].join(":"),

      NVC_Opt: {
        //Silent configuration && Sliding verification, scratch card verification code common configuration.
        //Application type identifier. Together with the use of the scene identifier (scene field), it determines the policy model used by the silent verification business scenario and the backend. You can find the corresponding appkey field value in the Configuration Management tab of the HMI console. Please be sure to fill it out correctly.
        appkey: "FFFF0N000000000093FF",
        //Scene ID. Together with the application type identifier (appkey field), it determines the policy model used by the silent verification business scenario and the backend. You can find the corresponding scene value in the configuration management tab of the HMI console. Please be sure to fill it out correctly.
        scene: "nc_login",
        token: this.nc_token,
        // Whether it is an HTML5 page. For the PC-side web page type, this parameter value needs to be filled in with false.
        isH5: false,
        // The wake-up method of secondary verification. True is floating layer, false is embedded.
        popUp: false,
        // Declare the target element ID that needs to be rendered for secondary validation.
        renderTo: "#captcha",
        // Callback parameters.
        nvcCallback: function(data) {
          // Where data is the value of the getNVCVal() function, which is the callback function after the secondary verification slide or the scratch card passes.
          // The data is uploaded with the service request, and the backend requests the AnalyzeNvc interface and returns 100 or 900.
          return;
        },
        // Business key field, which can be empty. This parameter can be used for pre-online testing. Please configure this field value as described in the Test section after code integration.
        // trans: {"nvcCode":700},
        trans: { nvcCode: 800 },

        // The language of the secondary verification component, the default is cn (Simplified Chinese). See the custom copy file for detailed information.
        language: "cn",
        // Configure the width of the Sliding Verification component when the sliding verification is performed as a secondary verification.
        customWidth: 300,
        // When the scratch card verification is performed as a secondary verification, the width of the scratch card assembly is configured.
        width: 300,
        // Configure the height of the scratch card assembly when the scratch card verification is performed as a secondary verification.
        height: 100,
        // When the scratch card verification is performed as the secondary verification, the picture resources of the two elements that need to be scraped are configured.
        elements: [
          "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
          "//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png",
        ],
        // When the scratch card verification is performed as the secondary verification, the background image at the time of the scraping is configured (the method of automatically applying the tile filling).
        bg_back_prepared:
          "//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png",
        // When the scratch card verification is performed as the secondary verification, the foreground image when the scratch is configured (only supports the base64 data stream).
        bg_front:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC",
        // When the wake-up scratch card verification is performed as the secondary verification, the icon resource displayed when the verification is passed is configured.
        obj_ok: "//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png",
        // When the scratch card verification is performed as the secondary verification, configure the background image displayed when the verification passes (automatically apply the tile fill method).
        bg_back_pass:
          "//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png",
        // When the scratch card verification is performed as the secondary verification, the icon resource displayed when the verification fails or is abnormal is configured.
        obj_error: "//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png",
        // When the scratch card verification is performed as the secondary verification, the background image displayed when the verification fails or is abnormal (the way of automatically applying the tile fill).
        bg_back_fail:
          "//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png",
        // Used to customize the copy when the scratch card verification is performed as a secondary verification. For detailed configuration methods, please refer to the custom copy document.
        upLang: {
          cn: {
            _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
            _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
            _ggk_loading: "加载中",
            _ggk_fail: [
              "呀，盾牌不见了<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题",
            ],
            _ggk_action_timeout: [
              "我等得太久啦<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题",
            ],
            _ggk_net_err: [
              "网络实在不给力<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题",
            ],
            _ggk_too_fast: [
              "您刮得太快啦<br/>请",
              "javascript:noCaptcha.reset()",
              "再来一次",
              "或",
              "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN",
              "反馈问题",
            ],
          },
        },
      },
      NC_Opt: {
        renderTo: "#captcha",
        appkey: "FFFF0N000000000093FF",
        scene: "nc_login",
        token: this.nc_token,
        customWidth: 300,
        customHeight: 54,
        trans: { key1: "code0" },
        elementID: ["usernameID"],
        is_Opt: 0,
        language: "en",
        isEnabled: true,
        timeout: 3000,
        times: 5,
        callback: this.aliSlideDone,
      },
    };
  },
  mounted() {
    if (window) {
      var nc = new noCaptcha(this.NC_Opt);
    } else {
      this.$alert("Alislide 로드 실패");
    }
  },
  methods: {
    aliSlideDone(data) {
      const ali = {
        ali_token: data.token,
        ali_sig: data.sig,
        ali_csessionid: data.csessionid,
      };
      this.$emit("ali-slide-done-event", ali);
    },
    aliSlideReset() {
      var nc = new noCaptcha(this.NC_Opt);
    },
  },
};
</script>
<style>
.nc_scale {
  background: #e6e6e6;
  /* 默认背景色 */
}
.nc_scale div.nc_bg {
  background: #8cd264;
  /* 滑过时的背景色 */
}
.nc-container .nc_scale span {
  height: 34px;
}
</style>
